/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import BasicLayout from "../../layouts/BasicLayout";
/* eslint-disable jsx-a11y/alt-text */
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
const imgs = [
  {
    link1:
      "https://tse1.mm.bing.net/th?id=OIP.3HxE46duG_3kc8jUgE8e6wHaFj&pid=Api&P=0&h=220",
    link2:
      "https://congthuong-cdn.mastercms.vn/stores/news_dataimages/2024/052024/07/00/tran-van-manh20240507001300.jpg?rt=20240507001301",
    description1:
      "Món ăn ngon trang trì cũng đẹp, nói chuyện với các cháu đầu bếp và phục vụ cỗ rát vui và cởi mở. Tôi hài lòng và sẽ ủng hộ lâu dài ",
    description2:
      "Đội ngũ đầu bếp số 1 số 2 Hải Dương có khác, đồ ăn rất ngon phục vụ quá nhiệt tình",
    name1: "Chị Lan Gia Lộc",
    name2: "Chú Hải Nam Sách",
  },
  {
    link1:
      "https://taytou.com/wp-content/uploads/2022/05/anh-Avatar-dai-dien-DepAnh-avatar-chu-cun-nau-cuoi-dep-cute.jpg",
    link2:
      "https://images2.thanhnien.vn/Uploaded/nuvuong/2022_12_04/317097199-9077169845630020-6360913673153753956-n-2121.jpg",
    description1:
      "Tuy mk đặt 1 món nhưng ship rất nhanh rất nhiệt tình ạ, ủng hộ lâu dài",
    description2:
      "Tổ chức liên hoan cho tổ dân phố được bên nấu cỗ Hải Dương đảm nhận thì yên tâm rồi, phục vụ chu đáo tận tình lắm",
    name1: "Anh Đức Tứ Kỳ",
    name2: "Chị Hồng Hải Dương",
  },
  {
    link1:
      "https://kenh14cdn.com/thumb_w/660/203336854389633024/2024/5/7/7da6d3f3-8326-48e7-924a-6e315b177fd3-17150696435081086268179.jpg",
    link2:
      "https://sohanews.sohacdn.com/160588918557773824/2024/5/8/byd-seal-41-17139345121991039979851-1715081383645509175602-1715131350003-17151313501601599075167-1715135990969-1715135991116308273350.jpg",

    description1:
      "4 mâm ngỗng mình đặt được phục vụ chu đáo, món ăn ngon nóng hợp khẩu vị mọi người. Mình cảm ơn các bạn nhiều",
    description2:
      "Món ăn ngon trang trì cũng đẹp, nói chuyện với các cháu đầu bếp và phục vụ cỗ rát vui và cởi mở. Tôi hài lòng và sẽ ủng hộ lâu dài ",

    name1: "Anh Dương Huy Hải Dương",
    name2: "Chị Hoa Thanh Miện",
  },
];

const project = [
  {
    img: "https://naucohaiphong.com/files/media/202402/z5174018193868_418e654789f42aed31aea41ff04718d5.jpg",
    name: "Tiệc tân gia tại nhà anh Đăng ở Hải Dương",
  },
  {
    img: "https://naucohaiphong.com/files/media/202402/z4930283399835_0d993b1de19ec6bb39634f4ee5bf08ba.jpg",
    name: "Tiệc Buffet cho 80 khách tại đại học Thành Đông ",
  },
  {
    img: "https://naucohaiphong.com/files/media/202402/z4837741227042_65f4806ded12dcc42166699adf19ff67.jpg",
    name: "25 Mâm lợn mán đủ món nhà anh Nam Gia Lộc",
  },
  {
    img: "https://naucohaiphong.com/files/media/202402/z5066907783025_dc0351cf4a4a2347033c1f449018d2cd.jpg",
    name: "14 Mâm ăn hỏi chị Tâm ở Nam Sách",
  },
  {
    img: "https://i.ytimg.com/vi/42WH6wDK8-c/maxresdefault.jpg",
    name: "4 Mâm ngỗng 10 món mang về cho chị Lan Thanh Miện",
  },
  {
    img: "https://jamja.vn/blog/wp-content/uploads/2017/10/cach-lam-lau-thai-thap-cam-18.jpg",
    name: "Lẩu mang về cho anh Huy Hải Dương",
  },
];

const Home = () => {
  return (
    <div className="md:mt-16 mt-4">
      <BasicLayout>
        <div className="grid grid-cols-12 md:gap-16">
          <div className="md:col-span-4 col-span-12">
            <img
              className="rounded mt-9 w-full"
              src="https://thoidai.com.vn/stores/news_dataimages/trang.chu/012020/21/11/4310_6.jpg"
            />
          </div>
          <div className="md:col-span-8 col-span-12 text-[#6e6e86] font-semibold">
            <span className="text-slate-700 md:block hidden">Giới thiệu</span>
            <h1 className="font-bold text-4xl text-black md:mt-1 mt-3">
              Dịch Vụ Ship Món Ăn - Nấu Cỗ Tại Nhà ở Hải Dương
            </h1>
            <div className="mt-4">
              <span className="inline-block mr-1 font-semibold">
                Nấu Cỗ Hải Dương
              </span>
              <span>
                là một trong những đơn vị nhận nấu cỗ lâu đời nhất ở Hải Dương
                với đội ngũ là những bếp trưởng bếp phó ở các Nhà Hàng lớn tại
                Hải Dương...
              </span>
            </div>
            <span className="inline-block mt-4">
              - Dịch vụ nấu cỗ tại nhà – Đầy đủ bát đũa cốc ly làm nóng đồ ăn
              tại nhà và nhận làm cỗ từ 1 mâm.
            </span>
            <span className="inline-block mt-1">
              - Dịch vụ bán đồ mang về + ship đồ từ 1 món ở Hải Dương.
            </span>
            <span className="block mt-1">
              - Gia đình bạn đang cần 1 nồi lẩu, bạn đang nhậu nhưng thiếu
              mồi... Liên hệ ngay để được trải nghiệm dịch vụ ship cỗ từ 1 món.
            </span>
            <span className="block mt-1">
              - Cam kết đồ ăn ngon.
            </span>
            <span className="block mt-1">
              - Cam kết phục vụ tốt, phục vụ theo yêu cầu.
            </span>
          </div>
        </div>
        <div>
          <span className="font-bold text-4xl block text-center mt-10 sm:mt-20 mb-5">
            Mâm Cỗ Khách Đặt
          </span>
          <div className="grid grid-cols-12 gap-8 ">
            {project.map((item, index) => {
              return (
                <div
                  key={index}
                  className="col-span-12 lg:col-span-4 md:col-span-6"
                >
                  <div>
                    <img
                      className="w-full h-[250px] rounded object-cover"
                      src={item.img}
                    />
                  </div>
                  <div className="font-semibold text-lg mt-2">{item.name}</div>
                </div>
              );
            })}
          </div>
        </div>
      </BasicLayout>
      <div className="bg-[#f1f8fb] mt-12">
        <h1 className="font-bold text-4xl text-center py-4 sm:py-8">
          Nhận Xét Khách Hàng
        </h1>
        <div className="md:h-[300px] h-[450px] max-w-[1180px] m-auto">
          <Swiper
            style={{ height: "100%" }}
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            navigation={false}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
          >
            {imgs.map((item, index) => {
              return (
                <SwiperSlide>
                  <div
                    key={index}
                    className="grid grid-cols-12 px-0 md:px-20 gap-0 md:gap-8"
                  >
                    <div className="col-span-12 md:col-span-6  p-5 text-center bg-white  h-[200px] sm:h-[250px] rounded">
                      <h3 className="h-[50%] text-[#6e6e86] font-semibold mt-5">
                        {item.description1}
                      </h3>
                      <div className="flex items-center mt-6 justify-center">
                        <img
                          src={item.link1}
                          className="rounded-[50%] object-cover h-10 w-10"
                        />
                        <span className="font-semibold text-2xl inline-block ml-6 text-left">
                          {item.name1}
                        </span>
                      </div>
                    </div>
                    <div className="md:col-span-6 p-5 col-span-12 text-center bg-white h-[200px] sm:h-[250px] rounded">
                      <h3 className="h-[50%] text-[#6e6e86] font-semibold mt-5">
                        {item.description2}
                      </h3>
                      <div className="flex items-center mt-6 justify-center">
                        <img
                          src={item.link2}
                          className="rounded-[50%] object-cover h-10 w-10"
                        />
                        <span className="font-semibold text-2xl inline-block ml-6 text-left">
                          {item.name2}
                        </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Home;
